;(function () {

"use strict";

var sendEmail = false;

var ImportFormView = Backbone.View.extend({
  initialize: function () {
    console.log('init import form view');
  },
  submit: function (e) {
    this.$el.find('input[type="file"]').trigger('click');
    return false;
  },
  post: function (e) {
    console.log('completed input. sending data');

    var formData = new FormData();
    var files = this.$el.find('input[type="file"]')[0].files;
    var len = files.length;

    for (var i = 0; i < len; i++) {
      formData.append("export", files[i]);
    }

    if (sendEmail) {
      if ($('input.alt-email').val()) {
        formData.append("email", $('input.alt-email').val());
      }
    }

    formData.append("__shop__", window.data.shop);

    var request = new XMLHttpRequest();
    request.addEventListener("load", _.bind(this.onComplete, this));
    request.open("POST", "import");
    request.setRequestHeader("Authorization", "Bearer " + window.sessionToken);
    request.send(formData);

    // ShopifyApp.flashNotice("Starting Import");
    ShopifyApp.Bar.loadingOn();
  },
  onComplete: function (d) {
    ShopifyApp.Bar.loadingOff();

    d = JSON.parse(d.srcElement.responseText);

    if (d.status === 'error') {
      ShopifyApp.Modal.alert({
        title: 'Import Failed',
        message: d.message
      });
    } else {
      ShopifyApp.Modal.alert({
        title: 'Import Successful',
        message: "The import process has begun. It should take no more than one hour to complete. Please do not modify your store during this time. When the import is finished the store owner will receive an email in his or her inbox."
      });

      this.$el.find('button[type="submit"]').addClass("disabled").attr('disabled', 'disabled').text('Running Import');
    }
  },
  events: {
    'submit': 'submit',
    'change input': 'post'
  }
});

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('init import page');
    new ImportFormView({el: this.$el.find('form').first()});
  },
  events: {
    'click .remove-data': function (e) {
      console.log('clicked remove data');

      $.post('/remove', function (d) {
        console.log(d);
      });

      return false;
    },
    'change input[name="diff-email"]': function (e) {
      if ($(e.target).is(':checked')) {
        sendEmail = true;
        $(e.target).parent().parent().next().show();
      } else {
        sendEmail = false;
        $(e.target).parent().parent().next().hide();
      }
    }
  }
});

module.exports = PageView;

}());